module.exports = "<span class=\"collectionZoneInlineMessage--errorQuanity input-container\">\r\n\t<span class=\"input-error\" ng-bind-html=\"inlineMessage.message.errorMessage\"></span>\r\n</span>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/collectionzone/inline-messages/error-quantity.html
 ** module id = 907
 ** module chunks = 1
 **/